import { render, staticRenderFns } from "./goldInvoice.vue?vue&type=template&id=fef51f4e&"
import script from "./goldInvoice.vue?vue&type=script&lang=js&"
export * from "./goldInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports